// extracted by mini-css-extract-plugin
export default {"userinfowrap":"messagemodal_userinfowrap__pNScD"};